import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ExternalLessonView = ({ lesson }) => {
  return (
    <div className="bg-card rounded-lg p-12 text-center">
      <div className="w-14 h-14 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Link" size={24} className="text-accent" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">External Resource</h3>
      <p className="text-muted-foreground text-sm mb-6 max-w-md mx-auto">
        This lesson lives on an external site. Open it in a new tab to continue.
      </p>
      {lesson?.externalUrl ? (
        <a href={lesson?.externalUrl} target="_blank" rel="noopener noreferrer">
          <Button variant="default" iconName="ExternalLink" iconPosition="right">
            Open Resource
          </Button>
        </a>
      ) : (
        <p className="text-sm text-destructive">No link has been added to this lesson yet.</p>
      )}
    </div>
  );
};

export default ExternalLessonView;
